<!-- Render Section -->
<ion-content>
  <div class="container" *ngIf="modalData[typeId]?.template == TempC.DEFAULT">
    <div>
      <h3>Confirmación</h3>
    </div>
    <div class="description">¿ Estas seguro de ejercer esta acción ?</div>
    <br />
    <ion-row>
      <ion-col size="12" size-sm="6" push-sm="6">
        <ion-button class="highlight" type="submit" (click)="onAccept()" expand="block"> Aceptar </ion-button>
      </ion-col>
      <ion-col size="12" size-sm="6" pull-sm="6">
        <ion-button fill="outline" type="button" (click)="onCancel()" expand="block"> Cancelar </ion-button>
      </ion-col>
    </ion-row>
  </div>

  <div class="container" *ngIf="modalData[typeId]?.template == TempC.DELAY">
    <div>
      <h3>¡Ey! ¡Quieto parao!</h3>
    </div>
    <div class="description">
      Estas a punto de confirmar tu pedido, tenemos que recordarte que
      <b>debido a la demanda actual puede que nos tardemos 1 día más en procesarlo</b>. ¿Quieres continuar?
    </div>
    <br />
    <ion-row>
      <ion-col size="12" size-sm="6" push-sm="6">
        <ion-button class="highlight" type="submit" (click)="onAccept()" expand="block">
          Claro que sí, guapi...
        </ion-button>
      </ion-col>
      <ion-col size="12" size-sm="6" pull-sm="6">
        <ion-button fill="outline" type="button" (click)="onCancel()" expand="block"> Nop </ion-button>
      </ion-col>
    </ion-row>
  </div>

  <div class="container" *ngIf="modalData[typeId]?.template == TempC.LIMIT">
    <div>
      <h3>¡Quieto parao ahí!</h3>
    </div>
    <div class="description">
      Te has topado con nuestra web en obras. Estamos poniéndonos más guapos, más fuertes y más grandes.
      <br />
      <br />
      <b>En unas horas podrás pagar tu pedido</b>. Mientras tanto puedes dejarlo guardado, nosotros te lo cuidamos.
      <br />
      <br />
      Tienes 2 opciones:
      <ul>
        <li>Guardar tu pedido</li>
        <small>En el carrito, pincha en "Guardar para más tarde".</small>
        <li>Dejarlo en el navegador</li>
        <small>Verás tu carrito si nos visitas luego desde el mismo navegador.</small>
      </ul>
    </div>

    <ion-row>
      <ion-col size="12">
        <ion-button class="highlight" type="submit" (click)="onAccept()" expand="block">
          <div><span>Entendido</span><br /></div>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>

  <div class="container" *ngIf="modalData[typeId]?.template == TempC.CANARY">
    <div>
      <h3>Envío a las Islas Canarias</h3>
    </div>
    <div class="description">
      Recuerda: <em>Los gastos de envío no incluyen <strong>DUA</strong> ni <strong>GAS</strong>.</em>
      <br />
      <br />
      ¿Deseas continuar con tu pedido?
    </div>
    <br />
    <ion-row>
      <ion-col size="12" size-sm="6" push-sm="6">
        <ion-button class="highlight" type="submit" (click)="onAccept()" expand="block"> Sí </ion-button>
      </ion-col>
      <ion-col size="12" size-sm="6" pull-sm="6">
        <ion-button fill="outline" type="button" (click)="onCancel()" expand="block"> No </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>

<!-- Template Section -->
<ng-template #Void>
  <div class="responsive-size"></div>
</ng-template>

<!-- >DEFAULT -->
<!-- En caso defecto de algúna acción... -->
<ng-template #Default> </ng-template>

<!-- >DELAY -->
<!-- En caso de que se tenga que notificar que habrá un retraso -->
<ng-template #Delay> </ng-template>

<!-- >LIMIT -->
<!-- En caso de que se haya superado las compras para este dia -->
<ng-template #Limit> </ng-template>

<!-- >LIMIT -->
<!-- En caso de que se haya superado las compras para este dia -->
<!-- <ng-template #Canary>
  

  
</ng-template> -->

<!-- 2da opcion principal guardar orden para mas tarde -->

<!-- //Para futuro poner con templates saneados para agregar estilos por string -->
<!-- <div class="ql-editor" [innerHTML]="row.message | safevalue"></div>  -->
